import CustomServicesList from '../../../models/CustomServicesList';
import Observable from '../../../decorators/Observable';
import Action from '../../../decorators/Action';
import BusinessDescriptionWizardData from './BusinessDescriptionWizardData';
import { IWizardDataModel } from '../../../models/IWizardDataModel';
import WizardSessionData from '../../../services/WizardSessionData';

class BusinessDescriptionModel
  extends CustomServicesList
  implements IWizardDataModel
{
  @Observable()
  public isAddSocialProfileModalOpen: boolean = false;

  @Observable()
  public businessDescriptionWizardData = new BusinessDescriptionWizardData();

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  openAddSocialProfileModal() {
    this.isAddSocialProfileModalOpen = true;
  }

  @Action()
  closeAddSocialProfileModal() {
    this.isAddSocialProfileModalOpen = false;
  }

  getWizardData(): any {
    return this.businessDescriptionWizardData.getWizardData();
  }
}

let model = new BusinessDescriptionModel();
WizardSessionData.addModel(model);
export default model;
